module.exports = __webpack_public_path__ + "media/img/frontend_application/bg-upgrade-6e439c7ce376371756ae18a506641536.png";